import React from 'react'

function Home() {
    return (
        <div className="layout">
            <h1>Analyse de comportements touristiques avec <i>e-Khonsou</i></h1>
            <p><i>e-Khonsou</i> est un outil d'analyse de comportements touristiques basé sur les commentaires des utilisateurs provenant de Web.<br/>
            Les travaux réalisés au sein du laboratoire <a href="https://www.devinci.fr/research-center/">DVRC</a> en collaboration avec l'<a href="https://irest.pantheonsorbonne.fr/">IREST</a> donnent lieu à de nouveaux questionnements sur le monde du tourisme.<br/>
            Que ce soit sur des techniques de théorie des graphes, des outils statistiques, d'analyse textuelle, de Machine Learning, Data Mining, <i>e-Khonsou</i> s'enrichit continuelle de ses produits de recherche.</p>
            <p>Le nom <i>Khonsou</i> vient du dieu de l'égypte antique du voyage, fils de Mout et Amon. C'est donc une invitation au voyage et à l'imaginaire.<br/>
            <img src="/figs/khonsou.png" alt="e-Khonsou en hiératique"/></p>
        </div>
    );
}

export default Home;
